import { z } from 'zod'

/**
 * Font Value Object
 * Represents a font with its name and base64-encoded data
 */

export const FontSchema = z.object({
  name: z.string(),
  url: z.string().url(),
  preview: z.string(), // base64 SVG preview
  weight: z.number(),
  italic: z.boolean(),
})

export type Font = z.infer<typeof FontSchema>

export const FontListSchema = z.array(FontSchema)
export type FontList = z.infer<typeof FontListSchema>
